<template>
    <div>
        <div class="image-picker">
            <div class="image-picker__preview" :style="preview_style">

                <div class="image-picker__error" v-if="error_msg">
                    <span>{{error_msg}}</span>
                </div>
                <img v-if="image_src" :src="image_src" class="image-picker__preview-img">

            </div>

            <input type="file" value="pick file" class="image-picker__hidden-input" ref="file_picker" @change="imagePicked()">  
            <b-btn  class="mt-3 tb-button tb-button--white font-thin" @click="$refs.file_picker.click()" >{{text}}</b-btn>
<!--            variant="outline-primary"-->
        </div>
<!-- 
        <b-form-input v-model="error_msg"></b-form-input> -->
    </div>
    
</template>

<script>
export default {

    props:[
        'width', 'height', 'src','bg_color', 'text'
    ],

    data(){
        return {
            image_src:null,
            uploaded_src:null,
            max_size: 1000000,
            error_msg:null
        }
    },

    watch: {
        src(new_src) {
            this.image_src = new_src;
            this.$refs.file_picker.value = "";
        }
    },

    mounted(){
        this.image_src = this.src;
    },

    computed:{
        preview_style(){
            if(this.bg_color){
                return {backgroundColor:this.bg_color};
            }
            return {}
        }
    },

    methods:{
        imagePicked(){
            //reset errors
            this.error_msg = null;
            const file = this.$refs.file_picker.files[0];

            if(this.fileSizeToLarge(file)){
                this.error_msg = 'File too large, must be less than ' + (this.max_size / 1000) + ' Kb';
                return;
            }

            const file_reader = new FileReader();
            file_reader.onload = this._readerLoaded;
            file_reader.readAsDataURL(file);
        },
        _readerLoaded(e){

            const data_url  = e.target.result;
            //save unresized
            this.uploaded_src = data_url;
            //TODO this might leak memory, need to keep a reference to,
            //and destroy this image after use
            const image = new Image();
            image.onload = this._imageLoaded;
            image.src = data_url;
        },
        _imageLoaded(e){
            const image = e.target;
            if(this.imageTooSmall(image)){
                this.error_msg = 'Image is too small, please choose a larger one';
                return;
            }
            this.resizeImage(image);

        },
        fileSizeToLarge(file){
            return file.size > this.max_size;
        },
        imageTooSmall(image){
            return image.width < this.width || image.height < this.height;
        },
        resizeImage(image){
            //Need to do some maths here, to resize without distorting.
            //simple option is to calculate height based on image ration, which is what we want to
            //do for logos.
            //TODO implement crop
            if(this.width && this.height){
                console.log('crop required');
                this.image_src = this.cropFromCenter(image);
            }else if(this.width){
                console.log('scale to width required');
                this.image_src = this.scaleToWidth(image);
            }else if(this.height){
                console.log('scale to height required');
                this.image_src = this.scaleToHeight(image);
            }else{
                console.log('no scaling required')
                this.image_src = this.uploaded_src;
            }

            //cleanup - not entirly sure this is required
            this.remove(image);

            this.$emit('image-picked', this.image_src);
        },
        scaleToWidth(image){
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = this.width;
            canvas.height = canvas.width * (image.height / image.width);

            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            return canvas.toDataURL('image/png');
        },
        scaleToHeight(image){
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = canvas.height * (image.width / image.height);
            canvas.height = this.height;

            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            return canvas.toDataURL('image/png');
        },

        cropFromCenter(image){

            //TODO this doesnt do what it says! It scales by width, then crops/fills.
            //so if source image has a widfer aspect ration, it fills (with transparent pixels)
            //it should probably work more like css cover, so no empty pixels
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.height = this.height;
            canvas.width = this.width;
            ctx.drawImage(image, 0, 0, image.width, image.width * (canvas.height / canvas.width), 0, 0, canvas.width, canvas.height);
            return canvas.toDataURL('image/png');
        },

        remove(image){
            image.onload = null;
            image = null;
        }

    }
}
</script>

<style lang="scss" scoped>

.image-picker{}
.image-picker__preview{
    min-height: 200px;
    /*background: #e6e6e6;*/
    /*border: 1px solid #ced4da;*/
    overflow: hidden;
    position: relative;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}
.image-picker__error{
    position: absolute;
    top:0;right:0;bottom:0;left:0;
    background-color: #c16767;
    color:white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.image-picker__preview-img{
    max-width: 100%;
}
.image-picker__hidden-input{
    display: none;
}
</style>
